export default "__VITE_ASSET__f4afa9b3__"